import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import { LayoutDashboard } from 'Components/Layout/Dashboard'
import { SectionTitle } from 'Components/Section/SectionTitle'
import { SectionWrapper } from 'Components/Section/SectionWrapper'
import { ButtonEditInsideSection } from 'Components/Buttons/ButtonEditInsideSection'
import { UserDetailsWrapper } from 'Components/UserManagement/UserDetailsWrapper'

import { getUserById } from 'Reducers/Users/actions'

import UserManagementIcon from 'Assets/Images/icons/userManagement'
import { PATHS } from 'Config/Routing/paths'
import UserInfo from './UserInfo'
import StyledBreadcrumbs from '../../../../Components/StyledBreadcrumbs'

class UserManagementDetailsView extends PureComponent {
  componentDidMount = ({ getUserById, match } = this.props) => {
    getUserById(match.params.userId)
  }

  renderBreadcrumbs() {
    return (
      <div>
        <StyledBreadcrumbs
          icon={<UserManagementIcon style={{ width: 24 }} />}
          breadcrumbs={[
            {
              label: 'User management',
              link: `${PATHS.main.dashboard}${
                PATHS.clientSettings.userManagement
              }`,
            },
            { label: 'Details' },
          ]}
        />
      </div>
    )
  }

  render({ userById } = this.props) {
    return (
      <LayoutDashboard>
        {this.renderBreadcrumbs()}
        <UserDetailsWrapper>
          <SectionWrapper className="section-wrapper first">
            <SectionTitle className="section-title">User Details</SectionTitle>
            <ButtonEditInsideSection
              onClickHandler={() =>
                this.props.history.push(this.props.match.url + '/edit')
              }
            />
            <UserInfo data={userById} />
          </SectionWrapper>
        </UserDetailsWrapper>
      </LayoutDashboard>
    )
  }
}

UserManagementDetailsView.propTypes = {
  userById: PropTypes.object.isRequired,
  getUserById: PropTypes.func.isRequired,
}

const mapStateToProps = state => ({
  userById: state.users.userById,
})

UserManagementDetailsView = connect(
  mapStateToProps,
  {
    getUserById,
  },
)(UserManagementDetailsView)

export default withRouter(UserManagementDetailsView)
